export default "__VITE_ASSET__f4a17e26__"